import React, {useEffect, useState} from "react";
import {getListcampaignV1} from "../../service/campaignService";
import {responsiveproductlist} from "../../utils/constant";
import { ItemGiftV2 } from "../Products/Item";


import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const Productgift1 =()=>{

    var [dataList, setdataList] = useState([]);
    const loadData =()=>{
        getListcampaignV1(0,30).then((response) => {
            if(response.status === 200){
                setdataList(response["message"]);
            }
        }); 
    }
    useEffect(()=>{
        loadData();
    },[])
    if(dataList.length>0){
    return(
        <div className="buy__grif">
                <div className="container m-auto container m-auto p-0">
                    <div className="row row--maint m-0 pb-4">
                        <div className="col-12 px-0">
                            <div className="maint__title">
                                <div className="row m-0">
                                    <div className="maint__title--left col-3 px-0">
                                        <h2 className="float-start fw-bold ">Mua hàng tặng quà</h2>
                                    </div>
                                    <div className="maint__title--middle col-8">
                                    </div>
                                    <div className="maint__title--right col-1 px-0">
                                        <div className="float-end position-relative"><a href="/mua-hang-tang-qua.html">Xem tất cả</a> <i className="fa-solid fa-chevron-right"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 px-0">
                            <div className="mant__item">
                                <div className="row m-0 p-0 position-relative">
                                    <Carousel key="CarouselGift"
                                        responsive={responsiveproductlist}
                                        autoPlay={false}
                                        slidesToSlide={4}
                                        fade={true}
                                        infinite={true}
                                        >
                                            { 
                                            dataList?.map((item, index)=>(
                                                <ItemGiftV2 key={index} item={item} index={index} showPriceRow='false'/>
                                            ))
                                            } 
                                    </Carousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
    )
}else{
    return null;
}
}
export default Productgift1;